module.exports = __webpack_public_path__ + "static/media/sent_mail_icon.b3677925.svg";


//////////////////
// WEBPACK FOOTER
// /src/globals/images/sent_mail_icon.svg
// module id = 1899
// module chunks = 0